import React, { Component } from 'react';

import _ from "lodash";
import { Form, Message } from 'semantic-ui-react'

import { translate } from "../../addons/Translate";

class VerifyPhoneForm extends Component {
	state = {
		data: {
			code: "",
		},
		loading: false,
		error_server: false,
		errors_response: {},
		errors: {}
	}

	onChangeCheckErrors(name){
		if(this.state.errors[name] !== undefined) {
			this.setState({
				errors: _.omit(this.state.errors, name)
			});
		}
	}

	onChange(e) {
		this.setState({
			...this.state,
			data: { ...this.state.data, [e.target.name]: e.target.value}
		});

		this.onChangeCheckErrors(e.target.name);
	}

	onSubmit = e => {
		e.preventDefault();
		const errors = this.validate(this.state.data);
		
		this.setState({ errors });
	
		if(Object.keys(errors).length === 0) {
			this.setState({loading: true})
			this.props.onSubmit(this.state.data)
				.then(res => {
					if(res.status === "error") {
						this.setState({
							errors_response: res.errors,
							loading: false
						})
					}
				})
				.catch(err => {
					if(err !== undefined) {
						this.setState({
							loading: false,
							errors_response: {
								code: err
							}
						});
					} else {
						this.setState({
							error_server: true,
							loading: false
						});
					}
				});
		}
	}

	validate(data) {
		const errors = {};

		if(!data.code) errors.code = true;

		return errors;
	}

	renderErrorMessage() {
		const { errors_response, error_server } = this.state;

		if(error_server) {
			return (
				<Message negative>
				    <p>{translate("xxltable.errors.server")}</p>
				</Message>
			);
		}

		if(Object.keys(errors_response).length > 0) {
			return (
				<Message negative>
					{Object.keys(errors_response).map(error => <div key={error}>{errors_response[error]}</div>)}
				</Message>
			);
		}

		return null;
	}

	render() {
		const { data, errors, loading } = this.state;

		return (
			<Form onSubmit={this.onSubmit.bind(this)} loading={loading}>
				{this.renderErrorMessage()}

				<Form.Input autoFocus placeholder={translate("xxltable.step1.sms_code")} name="code" value={data.code} onChange={this.onChange.bind(this)} error={!!errors.code} />

				<div className="ui center aligned container">
					<Form.Button positive>{translate("xxltable.step1.btn_verify_code")}</Form.Button>
				</div>
			</Form>
		);
	}
}

export default VerifyPhoneForm;


// WEBPACK FOOTER //
// ./src/components/forms/VerifySmsCodeForm.js